export default __webpack_public_path__ + "static/media/ten_one-min.6f7d0de5.png";